import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IMassiveUploadState } from './massive-upload';

const massiveUploadStateSelector =
  createFeatureSelector<IMassiveUploadState>('massiveUpload');

export const selectUploadFileResult = createSelector(
  massiveUploadStateSelector,
  (state: IMassiveUploadState) => state.uploadFileResult
);

export const selectUploadFileDataResult = createSelector(
  massiveUploadStateSelector,
  (state: IMassiveUploadState) => state.uploadFileDataResult
);
